import MuiInputLabel from '@mui/material/InputLabel';
import { styled } from '@mui/material/styles';

export const StyledInputLabel = styled(MuiInputLabel)(({ theme }) => ({
  '&.Mui-focused': {
    fontWeight: 600,
  },
  '&:focus-visible': {
    outline: `3px solid ${theme.palette.primary.light}`,
    outlineOffset: 2,
  },
})) as typeof MuiInputLabel;
